require("./bootstrap");

import "datatables.net-fixedheader-dt";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";

import * as Cascade from "./select2cascade";

import tippy, { animateFill, followCursor } from "tippy.js";
import $ from "jquery";

import Alpine from "alpinejs";

// import Select2Plugin from "select2";
import JQueryDataTables from "datatables.net";
import Toastify from "toastify-js";


import initKonamiListener from "./core/konami";
import Logger from "./core/console";
import datepicker from "./core/lifetime";
import copy from "./core/clipboard"
import jsoneditor from "./core/jsonedit";
import charts from "./core/charts";
import './core/tomselect';
import './core/select2'
// tomselect test
// import TomSelect from "tom-select";
// window.TomSelect = TomSelect;


$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() === b ? a : b);
	},
});
// $.select2 = Select2Plugin;
$.fn.select2.defaults.set("theme", "tailwindcss-3");
$.DataTables = JQueryDataTables;
$.fn.extend({
	/* eslint-disable */
	autoHeight: function () {
		/* eslint-enable */
		function autoHeight_(element) {
			return jQuery(element)
				.css({ height: 0, "overflow-y": "hidden" })
				.height(element.scrollHeight);
		}
		return this.each(function () {
			autoHeight_(this).on("input", function () {
				autoHeight_(this);
			});
		});
	},
});
$.each(["put", "delete", "head", "patch"], function (_i, method) {
	$[method] = function (url, data, success, dataType) {
		if (typeof data === "function") {
			dataType = dataType || success;
			success = data;
			data = undefined;
		}
		return $.ajax({
			url: url,
			type: method,
			dataType: dataType,
			data: data,
			success: success,
		});
	};
});

window.navigationBarSubmit = function () {
	event.preventDefault();
	this.closest("form").submit();
};

window.Alpine = Alpine;

window.Select2Cascade = Cascade.Select2Cascade;
window.Toastify = Toastify;
window.$ = window.jQuery = $;

new Logger();

// document.addEventListener("DOMContentLoaded", function () {
// 	document.querySelectorAll("select.select3").forEach((select) => {
// 		if (!select.dataset.tomSelectApplied) {
// 			// prevent double init
// 			new TomSelect(select, {
// 				create: false,
// 				sortField: { field: "text", direction: "asc" },
// 				placeholder: select.getAttribute("placeholder") || "",
// 				plugins: ["dropdown_input"],
// 				// Default to down
// 				dropdownDirection: "down",

// 				onDropdownOpen: function () {
// 					const controlRect = this.control.getBoundingClientRect();
// 					const dropdown = this.dropdown;
// 					const dropdownHeight = dropdown.offsetHeight || 200; // fallback height

// 					const spaceBelow = window.innerHeight - controlRect.bottom;
// 					const spaceAbove = controlRect.top;

// 					if (
// 						spaceBelow < dropdownHeight &&
// 						spaceAbove > dropdownHeight
// 					) {
// 						this.settings.dropdownDirection = "up";
// 						dropdown.classList.add("ts-dropdown-up");
// 					} else {
// 						this.settings.dropdownDirection = "down";
// 						dropdown.classList.remove("ts-dropdown-up");
// 					}
// 				},
// 			});
// 			select.dataset.tomSelectApplied = "true";
// 		}
// 	});
// });

let tip;
document.addEventListener("DOMContentLoaded", function () {
	Alpine.start();

	initKonamiListener();
	$.ajaxSetup({
		headers: {
			"X-CSRF-Token": $("meta[name=csrf-token]").attr("content"),
			Authorization:
				"Bearer " + $("meta[name=api-token]").attr("content"),
			Accept: "application/json",
		},
	});
	
	
	// const select2 = $(".select2");
	// if (select2.length > 0) {
	// 	select2.each(function () {
	// 		$(this).select2();
	// 		$(this).on("change", function (e) {
	// 			if (typeof $(this).attr("multiple") === "undefined") {
	// 				window.livewire.emit($(this).attr("id"), e.target.value);
	// 			} else {
	// 				window.livewire.emit($(this).data("emit-to"), [
	// 					$(this).select2("val"),
	// 					$(this).data("emit-more"),
	// 				]);
	// 			}
	// 		});
	// 	});
	// 	const select2reset = function () {
	// 		$(".select2").select2().val(null).trigger("change");
	// 	};
	// 	$(document).on("reset", select2reset);
	// 	$(document).on("select2reset", select2reset);
	// }
	// const select2cascade = $(".select2cascade");
	// if (select2cascade.length > 0) {
	// 	select2cascade.each(function () {
	// 		const options = { width: "resolve" };
	// 		new window.Select2Cascade(
	// 			$("#" + $(this).data("depends")),
	// 			$(this),
	// 			$(this).data("url"),
	// 			options
	// 		);
	// 	});
	// }
	
	// select2Setup()
	$(document).on("reload", function () {
		location.reload();
	});
	const datatable = $("table.datatable");
	if (!location.pathname.startsWith("/rolesgui")) {
		if (datatable.length > 0) {
			datatable.each(function () {
				let $this = $(this);
				let table = $this.DataTable({
					dom: "Bfrtip",
					fixedHeader: {
						header: true,
						footer: true,
					},
					colReorder: true,
					stateSave: true,
					paging: false,
					buttons: ["print", "csvHtml5"],
				});
				let order = $this.data("table-order");
				if (order !== undefined) {
					let order_desc = $this.data("table-desc");
					if (order_desc !== undefined) {
						if (
							typeof order_desc === "string" ||
							order_desc instanceof String
						) {
							order_desc = order_desc === "true";
						}
						if (order_desc) {
							order_desc = "desc";
						} else {
							order_desc = "asc";
						}
					} else {
						order_desc = "desc";
					}
					let order_out;
					if (typeof order === "string" || order instanceof String) {
						let order_lst = order.split(",");
						order_out = [];
						order_lst.forEach(function (element) {
							let elements = element.split("-");
							if (elements.length === 1) {
								order_out.push([
									parseInt(elements[0]),
									order_desc,
								]);
							} else {
								let this_order_desc;
								if (!order_desc === "desc") {
									this_order_desc = "desc";
								} else {
									this_order_desc = "asc";
								}
								order_out.push([
									parseInt(elements[0]),
									this_order_desc,
								]);
							}
						});
					} else {
						order_out = [order, order_desc];
					}
					table.order(order_out).draw();
				}
				$this.removeAttr("hidden");
				table.fixedHeader.enable();
				table.colReorder.enable();
			});
		}
	}

	charts()
	copy(".copy");
	
	if ($(".postAdded").length > 0) {
		setInterval(function () {
			window.livewire.emit("postAdded");
		}, 300000);
	}

	function settup_tippy() {
		return tippy("[data-tippy]", {
			content: (reference) => reference.getAttribute("data-tippy"),
			animation: "scale",
			followCursor: "initial",
			arrow: false,
			allowHTML: true,
			animateFill: true,
			theme: "material",
			plugins: [animateFill, followCursor],
			interactiveDebounce: 750000000,
			interactive: true,
			appendTo: (reference) => reference.closest(".tippy-append"),
		});
	}
	tip = settup_tippy();
	$(document).on("tippy_reset", function () {
		$.each(tip, function () {
			this.destroy();
		});
		tip = settup_tippy();
	});

	jsoneditor()

	$("start--hidden").removeAttr("hidden");

	if ($(".postAdded").length) {
		const $searchInput = $("#search");
		let typingTimer;

		$searchInput.on("keyup", function () {
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function () {
				const searchQuery = $("#search").val().toLowerCase();
				$(".post_i").each(function () {
					const card = $(this);
					const cardSearchData = card.data("search").toLowerCase();
					card.toggleClass(
						"is-hidden",
						!cardSearchData.includes(searchQuery)
					);
				});
			}, 500);
		});
	}

	datepicker("#lifetime", "lifetime");
	console.log("Base app.js loaded");
});
